import React from "react";

const Shop = () => {
  return (
    <h1>Bienvenue sur la boutique BMS</h1>
  );
}

export default Shop;
